import { propOr } from 'ramda';
import { useInHouseJackpotsStore } from '../../store';

export const selectJackpotCurrency = () => propOr('', 'currency');

export const useGetJackpotCurrency = (): string =>
  useInHouseJackpotsStore<string>(selectJackpotCurrency());
